import React from 'react';
import { getFrontEndUrl } from 'utils/environment-util';

interface FoodLocationCard {
  category: string;
  location: string;
  link: string;
}

const popularFoodData: FoodLocationCard[] = [
  {
    category: 'Indian Meals',
    location: 'in San Francisco',
    link: `${getFrontEndUrl()}/homemade-food-delivery/san-francisco-ca/indian-cuisine#cuisine-carousel`,
  },
  {
    category: 'Thai Food',
    location: 'in Los Angeles',
    link: `${getFrontEndUrl()}/homemade-food-delivery/los-angeles-ca/thai-cuisine#cuisine-carousel`,
  },
  {
    category: 'Mexican Meals',
    location: 'in Los Angeles',
    link: `${getFrontEndUrl()}/homemade-food-delivery/los-angeles-ca/mexican-cuisine#cuisine-carousel`,
  },
  {
    category: 'South Indian Meals',
    location: 'in New York',
    link: `${getFrontEndUrl()}/homemade-food-delivery/new-york-ny/south-indian-cuisine#cuisine-carousel`,
  },
  {
    category: 'Mediterranean Cuisine',
    location: 'in Chicago',
    link: `${getFrontEndUrl()}/homemade-food-delivery/chicago-il/mediterranean-cuisine#cuisine-carousel`,
  },
  {
    category: 'Italian Food',
    location: 'in Chicago',
    link: `${getFrontEndUrl()}/homemade-food-delivery/chicago-il/italian-cuisine#cuisine-carousel`,
  },
  {
    category: 'Japanese Food',
    location: 'in San Francisco',
    link: `${getFrontEndUrl()}/homemade-food-delivery/san-francisco-ca/japanese-cuisine#cuisine-carousel`,
  },
  {
    category: 'Thai Cuisine',
    location: 'in Seattle',
    link: `${getFrontEndUrl()}/homemade-food-delivery/seattle-wa/thai-cuisine#cuisine-carousel`,
  },
];

export const PopularFoodLocations: React.FC = () => (
  <div className='flex w-full flex-col gap-4 py-6 md:gap-6 md:py-8'>
    <div className='text-red-950 leading-trim-both text-edge-cap justify-center self-stretch text-center text-2xl font-bold leading-[120%] sm:text-2xl md:text-left md:text-3xl'>
      Most Popular Homemade Food in Locations
    </div>

    <div className='grid grid-cols-2 gap-3 md:gap-4'>
      {popularFoodData.map((item, index) => (
        <div
          key={index}
          className='cursor-pointer overflow-hidden rounded-lg border border-neutral-200 shadow-sm transition-shadow hover:shadow-md'
          onClick={() => window.open(item.link, '_blank', 'noopener,noreferrer')}>
          <div className='rounded-t-lg bg-raspberry px-4 py-3 md:px-6 md:py-4'>
            <div className='justify-center text-center text-sm font-bold leading-relaxed text-white sm:text-base md:text-lg'>
              {item.category}
            </div>
          </div>

          <div className='border-t border-dashed border-neutral-300 bg-white px-4 py-3 md:px-6 md:py-4'>
            <p className='text-center text-sm font-medium text-neutral-700 sm:text-base'>{item.location}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
